import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconMailAdd$1 = /*@__PURE__*/ proxyCustomElement(class WppIconMailAdd extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-mail-add", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M19 6.45238C19 3.9934 17.0066 2 14.5476 2C12.0886 2 10.0952 3.9934 10.0952 6.45238C10.0952 8.91136 12.0886 10.9048 14.5476 10.9048C17.0066 10.9048 19 8.91136 19 6.45238ZM14.9529 6.85715L14.9533 8.8838C14.9533 9.10734 14.7721 9.28856 14.5485 9.28856C14.325 9.28856 14.1438 9.10734 14.1438 8.8838L14.1434 6.85715H12.1155C11.8922 6.85715 11.7111 6.67593 11.7111 6.45239C11.7111 6.22885 11.8922 6.04763 12.1155 6.04763H14.1432L14.1429 4.02322C14.1429 3.79967 14.3241 3.61845 14.5476 3.61845C14.7712 3.61845 14.9524 3.79967 14.9524 4.02322L14.9528 6.04763H16.9734C17.1968 6.04763 17.3778 6.22885 17.3778 6.45239C17.3778 6.67593 17.1968 6.85715 16.9734 6.85715H14.9529ZM16.9762 14.75V11.1215C17.4223 10.8891 17.8308 10.5945 18.1905 10.2494V14.75C18.1905 16.1529 17.0924 17.2994 15.7088 17.3768L15.5595 17.381H4.63095C3.22802 17.381 2.08156 16.2829 2.00416 14.8993L2 14.75V7.05952C2 5.65659 3.09808 4.51013 4.48166 4.43274L4.63095 4.42857H9.68899C9.52891 4.81243 9.413 5.2193 9.3476 5.64286H4.63095C3.88767 5.64286 3.27808 6.21528 3.21898 6.94334L3.21429 7.05952V7.40681L10.0952 11.0282L11.1518 10.472C11.5068 10.7722 11.9021 11.0262 12.3284 11.2248L10.378 12.2516C10.2263 12.3314 10.0492 12.3428 9.89024 12.2858L9.81246 12.2516L3.21429 8.77895V14.75C3.21429 15.4933 3.78671 16.1029 4.51476 16.162L4.63095 16.1667H15.5595C16.3028 16.1667 16.9124 15.5942 16.9715 14.8662L16.9762 14.75Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-mail-add-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-mail-add", "wpp-icon-mail-add-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-mail-add-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-mail-add-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconMailAdd$1);
      }
      break;
  } });
}

const WppIconMailAdd = WppIconMailAdd$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconMailAdd, defineCustomElement };
